<template>
  <div class="app-mnp-out-status content-wrapper text-base">
    <div>
      <div class="headline">
        <slot name="txtHeadline">Portierungsrelevante Daten</slot>
      </div>

      <div class="container-box">
        <div class="content-limiter">
          <slot name="txtBeforeContent">Portierungsrelevante Daten</slot>
          <div class="data">
            <div class="col">
              <p class="label">Datum:</p>
              <p>
                {{ getMnpOutStatusEntries.requestDate ? dateTimeFormatter(getMnpOutStatusEntries.requestDate) : '-' }}
              </p>
            </div>
            <div class="col">
              <p class="label">Kundentyp:</p>
              <p>{{ getMnpOutStatusEntries.customerType }}</p>
            </div>
            <div class="col">
              <p class="label">Nachname:</p>
              <p>{{ getMnpOutStatusEntries.lastName }}</p>
            </div>
            <div class="col">
              <p class="label">Vorname:</p>
              <p>{{ getMnpOutStatusEntries.firstName }}</p>
            </div>
            <div class="col">
              <p class="label">Geburtstag:</p>
              <p>{{ getMnpOutStatusEntries.birthdate ? dateTimeFormatter(getMnpOutStatusEntries.birthdate) : '-' }}</p>
            </div>
            <div class="col">
              <p class="label">Zu portierende Rufnummer:</p>
              <p>{{ getMnpOutStatusEntries.msisdn }}</p>
            </div>
            <div class="col">
              <p class="label">Providererkennung:</p>
              <p>{{ getMnpOutStatusEntries.serviceProviderCode }}</p>
            </div>
            <div class="col">
              <p class="label">Kündigungsdatum:</p>
              <p>
                {{ getMnpOutStatusEntries.terminationDate ? dateTimeFormatter(getMnpOutStatusEntries.terminationDate) : '-' }}
              </p>
            </div>
            <div class="col">
              <p class="label">Gültigkeitsdatum OPT-in:</p>
              <p>
                {{ getMnpOutStatusEntries.optInValidity ? dateTimeFormatter(getMnpOutStatusEntries.optInValidity) : '-' }}
              </p>
            </div>

            <button :disabled="loadingPdf" @click="downloadPdf()" class="button button--primary">
              <span> Als PDF herunterladen</span>
              <img src="/files/lidl/images/new-icons/svg/file-pdf.svg" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { wrapQuery } from '../../../../../helper/wrapGQLQuery'
import transaction from '@/mixins/transaction'
import { splitError } from '@/helper/splitError'
import FileSaver from 'file-saver'

export default {
  name: 'ShowMnpOutStatus',
  mixins: [transaction('mnpOutStatus')],
  computed: {
    getMnpOutStatusEntries() {
      return this.mnpOutStatus
    }
  },
  data() {
    return {
      mnpOutStatus: null,
      loading: false,
      loadingPdf: false
    }
  },
  methods: {
    dateTimeFormatter(date) {
      return this.$config.calendar.formatter.dateFormatter.format(new Date(date))
    },
    downloadPdf: function() {
      this.loadingPdf = true
      const me = this
      const graphQlClient = me.$apolloProvider.defaultClient

      graphQlClient
        .query({
          query: gql`
            query mnpOutStatus {
              mnpOutStatusPdf {
                contentType
                document
              }
            }
          `
        })
        .then(response => {
          this.loadingPdf = false
          if (response.data.mnpOutStatusPdf !== null) {
            const decodedDocumentPdf = Uint8Array.from(atob(response.data.mnpOutStatusPdf.document), c => c.charCodeAt(0))
            const file = new Blob([decodedDocumentPdf], { type: response.data.mnpOutStatusPdf.contentType })
            FileSaver.saveAs(file, 'mnp-status.pdf')
          } else me.$store.commit('addError', 'Die PDF konnte nicht heruntergeladen werden.')
        })
        .catch(error => {
          this.loadingCSV = false

          splitError(error).forEach(e => me.$store.commit('addError', e))
        })
    }
  },
  apollo: {
    mnpOutStatus: function() {
      this.loading = true
      return wrapQuery(
        gql`
          query mnpOutStatus {
            mnpOutStatus {
              birthdate
              customerType
              firstName
              lastName
              msisdn
              optInValidity
              portingDate
              requestDate
              serviceProviderCode
              terminationDate
            }
          }
        `,
        this,
        'mnpOutStatus',
        {},
        () => {
          this.loading = false
        },
        {
          fetchPolicy: 'cache-first'
        },
        () => {
          this.loading = false
        }
      )
    }
  }
}
</script>
